import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { SET_AUTH_CTN, SET_AUTH_STATE, SET_AUTH_STEP, SET_CTN_READ_FROM_URL, SET_CTN_TYPE, SET_MOBILE_ID_CAPTCHA } from "../actions/actionTypes";
var getNewState = function getNewState(oldState, newData) {
  return _objectSpread(_objectSpread({}, oldState), {
    authorization: _objectSpread(_objectSpread({}, oldState.authorization), newData)
  });
};
export var authorization = function authorization(state, action) {
  switch (action.type) {
    case SET_AUTH_CTN:
      return getNewState(state, {
        authCtn: action.payload
      });
    case SET_AUTH_STEP:
      return getNewState(state, {
        authStep: action.payload
      });
    case SET_CTN_TYPE:
      return getNewState(state, {
        loginType: action.payload
      });
    case SET_AUTH_STATE:
      return getNewState(state, _objectSpread({}, action.payload));
    case SET_CTN_READ_FROM_URL:
      return getNewState(state, {
        ctnReadFromUrl: true
      });
    case SET_MOBILE_ID_CAPTCHA:
      return getNewState(state, _objectSpread({}, action.payload));
    default:
      return state;
  }
};